import React from "react";
import { Box, Typography } from "@mui/material";

const MAIN_FONT = "Noto Sans TC";
const TAB_HEIGHT = 48;

export default function LeaderboardSelectionTabs({
    leaderboards,
    currentIndex,
    onSelect,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                height: TAB_HEIGHT,
                flexShrink: 0,
                borderTop: "1px solid rgba(130, 60, 255, 0.5)",
                background: "rgba(10, 5, 30, 0.95)",
            }}
        >
            {leaderboards.map(({ label }, index) => {
                const isActive = index === currentIndex;
                return (
                    <Box
                        key={index}
                        onClick={() => onSelect(index)}
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            position: "relative",
                            borderRight:
                                index < leaderboards.length - 1
                                    ? "1px solid rgba(130, 60, 255, 0.3)"
                                    : "none",
                            background: isActive
                                ? "linear-gradient(180deg, rgba(130,60,255,0.2) 0%, transparent 100%)"
                                : "transparent",
                            transition: "background 0.2s",
                            "&:hover": {
                                background:
                                    "linear-gradient(180deg, rgba(130,60,255,0.15) 0%, transparent 100%)",
                            },
                        }}
                    >
                        {isActive && (
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: "10%",
                                    width: "80%",
                                    height: "3px",
                                    background:
                                        "linear-gradient(90deg, #00FF88, #00E5FF)",
                                    borderRadius: "0 0 3px 3px",
                                    boxShadow: "0 0 8px rgba(0, 229, 255, 0.8)",
                                }}
                            />
                        )}
                        <Typography
                            sx={{
                                fontFamily: MAIN_FONT,
                                fontSize: "10px",
                                fontWeight: isActive ? "900" : "500",
                                color: isActive ? "#00E5FF" : "rgba(180, 160, 220, 0.7)",
                                textShadow: isActive
                                    ? "0 0 8px rgba(0, 229, 255, 0.6)"
                                    : "none",
                                transition: "color 0.2s",
                                userSelect: "none",
                            }}
                        >
                            {label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
}